<template>
  <div>
    <BaseModal :config="InvestmentModalLabel" @ResetFields="resetFields" @SaveChanges="saveChanges">
      <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">
        <form ref="refInvestmentForm" id="InvestmentForm" action>
          <!-- <div
            id="error"
            class="alert alert-danger"
            role="alert"
            v-if="displayErrors"
            v-show="errors.items.length"
          >
            <span v-show="errors.has('InvestmentId')" class="alert-danger">
              {{ errors.first('InvestmentId') }}
              <br>
            </span>
            <span v-show="errors.has('InvestmentName')" class="alert-danger">
              {{ errors.first('InvestmentName') }}
              <br>
            </span>
          </div>-->
          <div id="pageErrors" class="alert alert-danger" v-if="pageErrors.length>0">
            <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="error in pageErrors" :key="error">{{ error }}</li>
            </ul>
          </div>
          <div
            id="Customerror"
            class="alert alert-danger"
            role="alert"
            v-show="customerrors.length && !errors.items.length"
          >
            <span v-show="customerrors.length" class="alert-danger">
              <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="error in customerrors" :key="error">{{ error }}</li>
              </ul>
            </span>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label>Investment ID</label>
              <input
                type="text"
                id="txtInvestmentId"
                name="InvestmentId"
                v-model="InvestmentInfo.parent.InvestmentID"
                class="form-control"
                placeholder="Investment Id"
                disabled
              />
            </div>
            <div class="form-group col-md-6">
              <label class="required-label">Investment Name</label>
              <input
                type="text"
                id="txtInvestmentName"
                name="InvestmentName"
                v-validate="'required'"
                v-model="InvestmentInfo.parent.Title"
                class="form-control"
                placeholder="Investment Name"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label">Investment Group</label>
              <div id="kendo-select">
                <kendo-dropdownlist
                  v-model="InvestmentInfo.parent.InvestmentGroup"
                  :data-source="InvestmentGroupOptions"
                  :data-text-field="'Option'"
                  :option-label="'Select Investment'"
                  :data-value-field="'Option'"
                ></kendo-dropdownlist>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label class="required-label">Statement Order</label>
              <input
                type="number"
                id="txtStatementOrder"
                name="StatementOrder"
                v-model="InvestmentInfo.parent.StatementOrder"
                class="form-control"
                placeholder="Statement Order"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <input
                class="k-checkbox form-control"
                type="checkbox"
                v-model="InvestmentInfo.parent.ShowOnFMVS"
                @change="onChangeShowOnFMVS()"
                id="chkShowFMV"
              />
              <label class="k-checkbox-label" for="chkShowFMV">Show on FMV Statement?</label>
            </div>
            <div class="form-group col-md-6">
              <!-- <input
                class="k-checkbox form-control"
                type="checkbox"
                v-model="InvestmentInfo.parent.HideNumberOnFMVS"
                id="chkHideFMV"
              />
              <label class="k-checkbox-label" for="chkHideFMV">Hide numbers on FMV Statement?</label>-->
              <label style="display:block">Hide Column Value on FMV Statement</label>
              <div id="kendo-select">
                <BaseMultiSelectComboBox
                  id="dpdHideFMV"
                  :dropdownOptions="dropdowns.HideNumberOnFMVS.dataSource"
                  :criteriaData="criteriaData"
                ></BaseMultiSelectComboBox>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label>Note</label>
              <textarea
                class="form-control"
                v-model="InvestmentInfo.parent.Note"
                rows="2"
                cols="50"
              ></textarea>
            </div>
          </div>

          <!-- <br/>
          <div class="form-row">
            <div class="form-group col-md-12">              
             <BaseGrid
              :mode="'incell'"
              :config="InvestmentFormConfig" 
              :data="InvestmentInfo.children.InvestmentValuation"
              :dropdownOptions="IVDropDowns"
              @DeleteItem="InvestmentDeleteitem"
            ></BaseGrid>
              
            </div>						
          </div>-->
        </form>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import $ from "jquery";
import BaseModal from "@/components/base/BaseModal.vue";
import apiUtil from "@/services/apiUtil.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import BaseModelInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";
import moment from "moment";
import funcUtil from "@/services/funcUtil.js";
import InvestmentFormConfig from "./InvestmentFormConfig.js";
import BaseGrid from "@/components/base/BaseGrid.vue";
import { mapActions, mapGetters } from "vuex";
import BaseMultiSelectComboBox from "@/components/base/BaseMultiSelectComboBox.vue";
import { isNullOrUndefined } from "util";

export default {
  name: "InvestmentForm",
  props: {
    InvestmentInfo: {},
    InvestmentModalLabel: {},
    partnerAutoCompleteDisplayedValue: {},
    programAutoCompleteDisplayedValue: {},
    ProgramUnitClassJsonData: {},
    SelectedHideNumberOnFMVS: {}
  },
  mixins: [apiUtil, funcUtil],
  computed: {
    ...mapGetters("getModule", ["withFilter", "getLocalInputControls"])

    // UnitClassOptions() {
    //   //console.log("before");
    //   var ddlValue = [];
    //   this.ProgramUnitClassJsonData.option.forEach(element => {
    //     ddlValue.push(element.UnitClass);
    //   });
    //   // this.ProgramUnitClassJsonData.forEach(function(key) {
    //   //   ddlValue.push(key);
    //   // });
    //   return ddlValue;
    // },
  },

  created() {
    this.getInputControls();
  },

  data: function() {
    return {
      BaseModelInvestment: BaseModelInvestment,
      BaseModelInvestmentValuation: BaseModelInvestmentValuation,
      BaseModelProgram: BaseModelProgram,
      BaseModelPartner: BaseModelPartner,
      InvestmentFormConfig: InvestmentFormConfig,

      displayErrors: false,
      BaseModelInputControl: BaseModelInputControl,
      criteriaData: {
        DropDownOptions: [],
        showDropdown: false,
        search: "",
        label: "Select Hide Column Value on FMVS",
        All: false
      },
      dropdowns: {
        TaxYear: { model: "", dataSource: [] },
        TaxQuarter: { model: "", dataSource: [] },
        InvestmentGroup: { model: "", dataSource: [] },
        HideNumberOnFMVS: { model: "", dataSource: [] }
      },
      customerrors: [],
      IVDeleteItemsArray: [],
      IVDropDowns: {},
      InvestmentGroupOptions: [],
      pageErrors: []
      // ProgramUnitClassJsonData:[],
      // programAutoCompleteDisplayedValue:"",
      // partnerAutoCompleteDisplayedValue:"",
    };
  },
  methods: {
    ...mapActions("postModule", [
      "CreateAllItems",
      "deleteAllItem",
      "UpdateItems",
      "CreateItems"
    ]),

    Validate() {
      const self = this;
      self.pageErrors = [];
      let form = self.InvestmentInfo.parent;

      if (!form.Title) {
        self.pageErrors.push("Investment Name is required");
      }
      if (!form.InvestmentGroup) {
        self.pageErrors.push("Investment Group is required");
      }
      if (!form.StatementOrder) {
        self.pageErrors.push("Statement Order is required");
      }
      if (self._validateSpecialCharacter(form.Title, "singleline")) {
        self.pageErrors.push(
          `Investment Name cannot have ${this.SingleLineSpecialChars}  Characters`
        );
      }
      if (self._validateSpecialCharacter(form.Note, "multiline")) {
        self.pageErrors.push(
          `Note cannot have ${this.MultiLineSpecialChars}  Characters`
        );
      }

      //Validation failed or success
      return self.pageErrors.length > 0 ? false : true;
    },

    isDataSourceDirty: function(DataSource) {
      let DataSourceDirty = false;
      DataSourceDirty = DataSource._data.some(obj => {
        if (obj.dirty === true) {
          return true;
        }
      });
      return DataSourceDirty;
    },
    // InvestmentDeleteitem(e){
    //     e.preventDefault();
    //     var gview = window.$("#InvestmentFormGrid").data("kendoGrid");
    //     // if(this.isDataSourceDirty(gview.dataSource)){
    //     //     this._AlertPopup("Please do save or cancel changes on the Investment Valuation before clicking on the Delete!","warning");
    //     // }
    //     // else{
    //         const message ="Are you sure you want to delete this record?";
    //         this._ConfirmationPopup(message,"DELETE").then((result) => {
    //             if(result.value) {

    //                 var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
    //                 if(dataItem.Id != 0 && dataItem.Id != null && dataItem.Id != undefined)
    //                 {
    //                   this.IVDeleteItemsArray.push({"Id": dataItem.Id});
    //                 }
    //                 var row = gview.tbody.find("tr[data-uid='" + dataItem.uid + "']");
    //                 gview.removeRow(row);

    //                 // //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
    //                 // //alert(JSON.stringify(dataItem));
    //                 // if(dataItem.Id != 0 && dataItem.Id != null && dataItem.Id != undefined)
    //                 // {
    //                 //     this.IVDeleteItemsArray.push({"Id": dataItem.Id});
    //                 //     let objIndex = this.InvestmentInfo.children.InvestmentValuation.findIndex(
    //                 //         obj => obj.Id == dataItem.Id
    //                 //     );
    //                 //     if(objIndex >=0)
    //                 //     {
    //                 //         this.InvestmentInfo.children.InvestmentValuation.splice(objIndex, 1);
    //                 //     }
    //                 //     var row = gview.tbody.find("tr[data-uid='" + dataItem.uid + "']");
    //                 //     // gview.editable.confirmation =false;
    //                 //     // window.confirm = function() { return true; };
    //                 //     gview.removeRow(row);
    //                 // }
    //                 // else{
    //                 //     var row = gview.tbody.find("tr[data-uid='" + dataItem.uid + "']");
    //                 //     // gview.editable.confirmation =false;
    //                 //     // window.confirm = function() { return true; };
    //                 //     gview.removeRow(row);
    //                 //     let objIndex = this.InvestmentInfo.children.InvestmentValuation.findIndex(
    //                 //         obj => obj.TaxYear == dataItem.TaxYear && obj.TaxQuarter == dataItem.TaxQuarter && obj.ProjectedValue == dataItem.ProjectedValue && obj.CurrentValue == dataItem.CurrentValue
    //                 //     );
    //                 //     if(objIndex >=0)
    //                 //     {
    //                 //         this.InvestmentInfo.children.InvestmentValuation.splice(objIndex, 1);
    //                 //     }
    //                 // }

    //             }
    //         });
    //     // }
    // },

    getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
      // self._getInputControls().then(response => {
      console.log(response);
      Object.keys(self.dropdowns).forEach(key => {
        self.dropdowns[key].dataSource = response[key];
        // self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
      });

      //Filling the Drop down options for the Grid DropDown Columns
      // this.toolbarDropDowns.TaxPeriod= this.dropdowns.TaxPeriod.dataSource;
      this.IVDropDowns.TaxYear = this.dropdowns.TaxYear.dataSource;
      this.IVDropDowns.TaxQuarter = this.dropdowns.TaxQuarter.dataSource;
      this.InvestmentGroupOptions = this.dropdowns.InvestmentGroup.dataSource;
      // });
    },
    GetCurrentGridData(gridId) {
      const grid = $("#" + gridId).data("kendoGrid");
      let gridArray = [];
      var gridData = grid.dataSource.data();
      for (let i = 0; i < gridData.length; i++) {
        let element = gridData[i];
        gridArray.push(element);
      }
      return gridArray;
      //console.log(this.ProgramInfoTemplate)
    },

    saveChanges: function() {
      let self = this;
      this.displayErrors = true;
      // const gview = window.$("#InvestmentFormGrid").data("kendoGrid");
      //Read current data from the Grid
      // this.InvestmentInfo.children.InvestmentValuation =  this.GetCurrentGridData("InvestmentFormGrid");
      // if(this.isDataSourceDirty(gview.dataSource)){
      //     this._AlertPopup("Please do save or cancel changes on the Investment Valuation before clicking on the Save!","warning");
      // }
      // else{
      // this.$validator.validate().then(result => {
      if (self.Validate()) {
        if (this.InvestmentModalLabel.modalAddorEdit == "add") {
          // Add Popup
          this.InvestmentInfo.parent.ShowOnFMVS =
            this.InvestmentInfo.parent.ShowOnFMVS == true ? "Yes" : "No";
          this.InvestmentInfo.parent.HideNumberOnFMVS = self.splitHideNumberOnFMVS(
            self.criteriaData.DropDownOptions
          );
          this.InvestmentInfo.parent.HideNumberOnFMVS;
          console.log(JSON.stringify(this.InvestmentInfo));
          let addFormValues = this.InvestmentInfo;

          // US #1180 : Investment ID
          const result = this.withFilter(self.BaseModelInvestment.list, "");

          if (result.length <= 0) {
            addFormValues.parent.InvestmentID = 500001;
          } else {
            //let lastElement = _.last(result);
            addFormValues.parent.InvestmentID = self._getIncrementalID(
              result,
              "InvestmentID"
            );
          }

          //let loader = this.$loading.show();
          self._APICrudPopup("APICrudpopup");

          // let joinedItems = { "joinedObject" : {
          //     parentConfig: BaseModelInvestment,
          //     childConfigs: [BaseModelInvestmentValuation]
          // }, "createData": addFormValues,"ParentKey": "InvestmentId" }
          // this.CreateJoinedItems(joinedItems).then((response) => {
          // //refresh the grid data only after the update gets completed
          // // console.log(response);
          //     // $("#programGrid").data().kendoGrid.dataSource.read();
          // //Having a timeout of 100 ms in order to avoid error in reading data after update
          //     // setTimeout(function(){
          //       loader.hide();
          //         self.$emit("SaveComplete");
          //         self._AlertPopup("Data Saved Successfully!","success");
          //         self.resetFields();
          //     // }, 100);
          // });
          let createItem = {
            list: this.BaseModelInvestment,
            payload: addFormValues.parent
          };
          this.CreateItems(createItem)
            .then(res => {
              self.$emit("SaveComplete");
              self._AlertPopup("Data Saved Successfully!", "success");
              // $("#BaseModal").modal("toggle");
              self.resetFields();
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });
        } else {
          // Edit Popup
          console.log(JSON.stringify(this.InvestmentInfo));
          this.InvestmentInfo.parent.ShowOnFMVS =
            this.InvestmentInfo.parent.ShowOnFMVS == true ? "Yes" : "No";
          this.InvestmentInfo.parent.HideNumberOnFMVS = self.splitHideNumberOnFMVS(
            self.criteriaData.DropDownOptions
          );
          let editForm = this.InvestmentInfo.parent;
          let updateItem = {
            list: this.BaseModelInvestment,
            payload: editForm
          };
          //let loader = this.$loading.show();
          this._APICrudPopup("APICrudpopup");
          this.UpdateItems(updateItem)
            .then(res => {
              //loader.hide();
              self.$emit("SaveComplete");
              self._AlertPopup("Data Saved Successfully!", "success");
              // $("#BaseModal").modal("toggle");
              self.resetFields();
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });
          // var editFormIV = this.InvestmentInfo.children.InvestmentValuation;

          // var editFormArray = [];
          // editFormArray.push(editForm);

          // //added Investment Valuation items in edit form
          // var addedIVArray = [];
          // addedIVArray=this.getaddeditems(editFormIV);
          // addedIVArray.forEach(element => {
          //     element.InvestmentId =  editForm.Id;
          // });

          // if(addedIVArray.length>0){
          // //using Create All method for newly added unit class and Vesting schedule info
          // var createdobject = {
          //       InvestmentValuation: {config: BaseModelInvestmentValuation, createData: addedIVArray}
          // };
          // this.CreateAllItems(createdobject).then(res => res);
          // //this._createAllItems(createdobject);
          // }

          // if(this.IVDeleteItemsArray.length>0){
          // //Deleted unit class items in edit form
          // var deletedobject = {
          //       InvestmentValuation: {config: BaseModelInvestmentValuation, deleteData: this.IVDeleteItemsArray}
          // };
          // this.deleteAllItem(deletedobject).then(res => res);
          // //this._deleteAllItems(deletedobject);
          // }

          // //Remove added items from update JSON
          // editFormIV = this.removeAddedItemsforUpdate(editFormIV);

          // let loader = this.$loading.show();
          // //using Update All method
          // var updateobject = {
          //       Investment: {config: BaseModelInvestment, updateData: editFormArray},
          //       InvestmentValuation: {config: BaseModelInvestmentValuation, updateData: editFormIV}
          // };
          // // this._updateAllItems(updateobject).then( (response) => {
          // this.UpdateAllItems(updateobject).then(res => {

          //     //refresh the grid data only after the update gets completed
          //     // console.log(response);
          //         // $("#programGrid").data().kendoGrid.dataSource.read();
          //     //Having a timeout of 100 ms in order to avoid error in reading data after update
          //         // setTimeout(function(){
          //           loader.hide();
          //             self.$emit("SaveComplete");
          //             self._AlertPopup("Data Saved Successfully!","success");
          //             self.resetFields();
          //         // }, 100);

          // });
        }
        // alert("Data Saved Successfully!");
        //  self._AlertPopup("Data Saved Successfully!","success");
        //   $("#BaseModal").modal("toggle");
        //   self.resetFields();
        $("#BaseModal").modal("toggle");
      } else {
        // $('#pageErrors').focus();
        let basemodal = $("#BaseModal");
        $("input:text:visible:first", basemodal).focus();
      }
      // });
      // }
    },
    resetFields: function() {
      // let self=this;
      //  this.$refs.refProgramForm.$refs.ProgramForm.reset();
      this.displayErrors = false;
      this.errors.clear();
      this.customerrors = [];
      // this.InvestmentInfo = {};
    },
    removeAddedItemsforUpdate: function(objdata) {
      let filteredData = objdata.filter(function(e) {
        return e["Id"] != 0 && e["Id"] != null && e["Id"] != undefined;
      });
      return filteredData;
    },
    getaddeditems: function(objdata) {
      let filteredData = objdata.filter(function(e) {
        return e["Id"] == 0 || e["Id"] == null || e["Id"] == undefined;
      });
      return filteredData;
    },

    // Show on FMVS change.
    onChangeShowOnFMVS: function(editFlag, showFMVS) {
      let self = this;
      self.criteriaData.showDropdown = false;
      let dpdHideNumFMVS = $("#dpdHideFMV")[0];
      if (editFlag === "add") {
        dpdHideNumFMVS.className = "disableDropDown";
      } else if (editFlag === "edit") {
        if (!!!showFMVS) {
          dpdHideNumFMVS.className = "disableDropDown";
        } else {
          dpdHideNumFMVS.className = "";
        }
      } else {
        if (!!!self.InvestmentInfo.parent.ShowOnFMVS) {
          dpdHideNumFMVS.className = "disableDropDown";
        } else {
          dpdHideNumFMVS.className = "";
        }
      }
    },

    //MultiSelect Hide Column on FMVS
    splitHideNumberOnFMVS(selectedArray) {
      const self = this;
      var selectedOptions = "";
      if (selectedArray.length) {
        selectedArray.forEach((element, index) => {
          if (index == 0) {
            selectedOptions = element.Option;
          } else {
            selectedOptions = selectedOptions + "," + element.Option;
          }
        });
      }
      return selectedOptions;
    },

    // Object of Selected Hide Number On FMVS
    assginSelectedHideNumberOnFMVS(inputStr) {
      const self = this;
      self.criteriaData.DropDownOptions = [];
      self.criteriaData.showDropdown = false;
      self.criteriaData.All = false;

      if (inputStr != null) {
        if (inputStr.length) {
          if (inputStr.indexOf(",") < 0) {
            inputStr = inputStr + ",";
          }
          var strColumn = inputStr.split(",");
          strColumn.forEach(strColumn => {
            self.dropdowns.HideNumberOnFMVS.dataSource.forEach(element => {
              if (element.Option === strColumn) {
                self.criteriaData.DropDownOptions.push(element);
              }
            });
          });
        }
        if (
          self.criteriaData.DropDownOptions.length ==
          self.dropdowns.HideNumberOnFMVS.dataSource.length
        )
          this.criteriaData.All = true;
        else this.criteriaData.All = false;
      }
    }
  },

  mounted() {
    const self = this;

    $("body").click(function(e) {
      if (
        $(e.target).closest(".vue-select-container").length == 0 &&
        $(e.target).closest(".vue-dropdown-panel").length == 0
      ) {
        if (self.criteriaData.DropDownOptions.length == 0) {
          self.criteriaData.DropDownOptions = [];
          self.criteriaData.All = false;
        }
        self.criteriaData.showDropdown = false;
      }
    });

    // this.getInputControls();
    this.onChangeShowOnFMVS();

    // alert(JSON.stringify(this.ProgramInfoFormConfig));
    this.resetFields();
    $("#BaseModal").on("shown.bs.modal", function() {
      $("input:text:visible:first", this).focus();
    });

    // $("#dtInvestmentDate").on("change",this.InvestmentDateChanged);
  },
  components: {
    BaseModal,
    BaseMultiSelectComboBox
  }
};
</script>
<style scoped>
.k-widget.k-autocomplete.k-header.k-state-default {
  width: 250px;
  background-color: yellow;
}

.disableDropDown {
  opacity: 0.7;
  pointer-events: none;
}

/* input[type="radio"]{
  width: 22px;
  margin-top: 4px;
}*/
/* .addButtonClass{
  /* margin-left:70%; 
} */
</style>
